import web from './web';
import runtime from '../runtime';
export * from './web';
const native = runtime.isNative() ? import('./native') : null;
const asyncMethods = ['getPermission', 'requestPermission', 'getStatus', 'enable', 'disable', 'subscribe',
    'prepareReadClear', 'sendTest', 'showLocal', 'start', 'setSession', 'logout', 'retry'];
const selected = native ? {
    isSupported: () => runtime.getPlatform() === 'ios' ? import.meta.env.VITE_NATIVE_PUSH_IOS_ENABLED === true : import.meta.env.VITE_NATIVE_PUSH_ANDROID_ENABLED === true,
    ...Object.fromEntries(asyncMethods.map(method => [method, async (...args) => (await native).default[method](...args)])),
    ...Object.fromEntries(['onReceived', 'onAction', 'onPermissionChanged', 'onRegistrationChanged'].map(method => [method, callback => {
        let cancelled = false, remove;
        native.then(module => { if (!cancelled) remove = module.default[method](callback); }).catch(() => {});
        return () => { cancelled = true; remove?.(); };
    }]))
} : web;
if (native) selected.unsubscribe = selected.disable;
export default selected;
